import { useAuth } from '../../context/Auth/useAuth';
import { CanhotoPage } from '../CanhotoPage';
import { Token } from '../Token';
import './styles.css';

export const App = () => {
  const auth = useAuth();
  return (
    <div className="mt-4 container">
      <div className="row mt-4" style={{ width: '100%', justifyContent: 'center' }}>
        <h3>Olá {auth.nome},</h3>
        <h3>Bem vindo ao Monitor Logistico!</h3>
        <div className="mt-2"></div>
        <img className="img-fluid" style={{ width: '60vh' }} src="logo512.png" alt="" />

        <div className="mt-4"></div>

        <hr />
        <div className="mt-2">
          <h3>Token</h3>
          <Token />
        </div>

        <div className="mt-4"></div>
        <hr />
        <div className="mt-2">
          <h3>Canhoto</h3>
          <CanhotoPage />
        </div>

        <div className="mt-4"></div>
      </div>
    </div>
  );
};

export default App;
